import { CONST } from '../utils/constants';
import DateUtils from '../utils/dateUtils';
import { WeekDay } from './periodTypes';

export interface LocationOpeningHours {
  id: string;
  locationId: string;
  fromWeekDay: WeekDay;
  tillWeekDay?: WeekDay;
  closed: boolean;
  fromTime?: string;
  tillTime?: string;
  createdDate: string;
  createdById?: string;
  companyId: string;
}

function toAPI(data: Partial<LocationOpeningHours>): any {
  return {
    Id: data?.id || CONST.emptyGuid,
    LocationId: data?.locationId || CONST.emptyGuid,
    FromWeekDay: data?.fromWeekDay ?? WeekDay.Monday,
    TillWeekDay: data?.tillWeekDay ?? undefined,
    Closed: data?.closed ?? false,
    FromTime: data?.fromTime || undefined,
    TillTime: data?.tillTime || undefined,
    CreatedDate:
      data?.createdDate || DateUtils.getCurrentLocalDateAsIsoString(),
    CreatedById: data?.createdById || undefined,
    CompanyId: data?.companyId || CONST.emptyGuid,
  };
}

function parse(data?: Partial<LocationOpeningHours>): LocationOpeningHours {
  return {
    id: data?.id || CONST.emptyGuid,
    locationId: data?.locationId || CONST.emptyGuid,
    fromWeekDay: data?.fromWeekDay ?? WeekDay.Monday,
    tillWeekDay: data?.tillWeekDay ?? undefined,
    closed: data?.closed ?? false,
    fromTime: data?.fromTime?.substring(0, 5) || undefined,
    tillTime: data?.tillTime?.substring(0, 5) || undefined,
    createdDate:
      data?.createdDate || DateUtils.getCurrentLocalDateAsIsoString(),
    createdById: data?.createdById || undefined,
    companyId: data?.companyId || CONST.emptyGuid,
  };
}

export default {
  parse,
  toAPI: toAPI,
};

export function getOpeningHoursText(
  openingHours: LocationOpeningHours,
  t: (key: string, obj?: any) => string
): string {
  const fromWeekDay = t(`app.day_of_week_short[${openingHours.fromWeekDay}]`);

  if (openingHours.tillWeekDay != undefined) {
    const tillWeekDay = t(`app.day_of_week_short[${openingHours.tillWeekDay}]`);

    return openingHours.closed
      ? t('app.opening_hours.range_closed', {
          fromDay: fromWeekDay,
          tillDay: tillWeekDay,
        })
      : t('app.opening_hours.range', {
          fromDay: fromWeekDay,
          tillDay: tillWeekDay,
          fromTime: openingHours.fromTime,
          tillTime: openingHours.tillTime,
        });
  }

  return openingHours.closed
    ? t('app.opening_hours.single_closed', {
        fromDay: fromWeekDay,
      })
    : t('app.opening_hours.single', {
        fromDay: fromWeekDay,
        fromTime: openingHours.fromTime,
        tillTime: openingHours.tillTime,
      });
}
